export const blockIconsTravelSpaNew = (
	<span className='material-symbols-outlined'>spa</span>
);
